// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2OdTz","choiceBoxes":"toolbarselects_choiceBoxes__2yz98","simpleField":"toolbarselects_simpleField__1QLWB"};